import { useWebSocket } from '../fork/@vueuse/core/use-websocket'

const SECURE_HOSTNAMES = [
  'app.staging.pulse.sleuth.io',
  'app.pulse.sleuth.io',
  'app.staging.skills.new',
  'app.skills.new',
]

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const isSecure = SECURE_HOSTNAMES.includes(location.hostname)
  const protocol = isSecure ? 'wss' : 'ws'
  // In production, no port needed. In dev, use configured pushpin port or fall back to page port (nginx)
  const port = isSecure ? '' : `:${config.public.pushpinPort || location.port}`

  let lastKnownId = ''
  const lastWsEvents = ref<WSEvent[]>([])

  const ws = useWebSocket(`${protocol}://${location.hostname}${port}/_api/stream/`, {
    immediate: false,
    // Use this to keep websocket connection alive if needed
    heartbeat: {
      interval: 15000,
      message: 'ping',
    },
    autoReconnect: true,
    onConnected(ws) {
      ws.send(
        JSON.stringify({
          type: 'event_subscription_request',
          since: lastKnownId,
        }),
      )
    },
    onMessage(ws, event) {
      const data = JSON.parse(event.data)
      if (data.id)
        lastKnownId = data.id

      lastWsEvents.value.unshift(data)
      // only keep the last 20 events to handle concurrent tool calls
      if (lastWsEvents.value.length >= 20)
        lastWsEvents.value.pop()
    },
    onError(ws, event) {
      console.error('WebSocket error.', event)
    },
  })

  return {
    provide: {
      ws,
      lastWsEvents,
    },
  }
})
